import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from "../misc/Headings.js";
import Navbarlogedin from "./Navbarlogedin";
import { Typography, TextField, Button, Grid } from "@mui/material";
// import EmailIllustrationSrc from "../../images/email-illustration.svg";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import "./CompletedInterviews.css";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup"; // eslint-disable-next-line
import Link from "@mui/material/Link";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Checkbox from '@mui/material/Checkbox';

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const TextColumn = styled(Column)((props) => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft
    ? tw`md:mr-12 lg:mr-16 md:order-first`
    : tw`md:ml-12 lg:ml-16 md:order-last`,
]);

const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(
  SectionHeading
)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`;

const Issue = () => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const subheading = "",
    heading = (
      <>
        <span tw="text-changed-100">Cancel a Mock Interview</span>
        <wbr />
      </>
    ),
    description =
      "Please Enter the Mock Interview ID and then proceed to cancel your mock interview.",
    textOnLeft = true;
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.

  return (
    <>
      <Navbarlogedin />
      <Container>
        <TwoColumn>
          <TextColumn textOnLeft={textOnLeft}>
            <TextContent>
              {subheading && <Subheading>{subheading}</Subheading>}
              <Heading>{heading}</Heading>
              {description && <Description>{description}</Description>}
            </TextContent>
            <Grid container spacing={1}>
              <Grid item xs={3}>
                <TextField
                  id="outlined-basic"
                  label="Enter the Mock Interview ID"
                  variant="outlined"
                  sx={{ width: "100%" }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={6}>
                <h5>Details of the Mock Interview </h5>
                <div className="interview-item-info">
                  <div className="interview-item">
                    <div className="interview-item-profile">
                      <img
                        src={require("../../images/photo.png")}
                        alt="Profile"
                      />
                      <button className="cust-btn view-btn">
                        View Profile
                      </button>
                    </div>
                    <div className="interview-item-info">
                      <div className="interviewer-head">
                        <h2>John Doe</h2>
                        <p>SDE, Google, California</p>
                      </div>
                      <div className="details flex">
                        <div className="detail">
                          <p className="detail-head">Profile</p>
                          <p className="detail-body">Data Science</p>
                        </div>
                        <div className="detail">
                          <p className="detail-head">Price</p>
                          <p className="detail-body">INR 900</p>
                        </div>
                        <div className="detail">
                          <p className="detail-head">Session Duration</p>
                          <p className="detail-body">30 Min</p>
                        </div>
                        <div className="detail">
                          <p className="detail-head">Interview Slot</p>
                          <p className="detail-body">[5:00PM - 5:45PM]</p>
                          <p className="detail-body">20 June, 2022</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <FormControl
                sx={{ m: 3 }}
                component="fieldset"
                variant="standard"
              >
                <FormLabel component="legend">
                  Why do you want to cancel this mock interview
                </FormLabel>
                <FormGroup>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                  >
                    <FormControlLabel
                      control={<Radio />}
                      value="one"
                      label="I got something else to do at that time"
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="two"
                      label="I checked the profile/resume of this student later on, and did not find it suitable"
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="three"
                      label="I am not interested to take mock interviews in this profile anymore"
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="four"
                      label="I want to take mock interview of another student in this slot"
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="five"
                      label="Other Issues"
                    />
                    <TextField
                      id="outlined-multiline-static"
                      label="Describe your issue(s) in detail"
                      multiline
                      rows={4}
                      sx={{ mt: 2 }}
                    />
                  </RadioGroup>
                </FormGroup>
              </FormControl>
            </Grid>

            <Grid item sx={{ mt: 2, mb: 2 }}>
              <Typography>
                If the current interview slot does not suit you well, you can
                better Ask the Student to Reschedule this Mock Interview as per
                your availability rather than cancelling it
                {/* {" "}
                <Link href="#" underline="hover">
                  {"Ask the Student to Reschedule this Mock Interview as per your availability "}
                </Link>{" "} */}
              </Typography>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  label="Ask the Student to Reschedule this Mock Interview as per your availability"
                />
              </FormGroup>

              <Button
                sx={{ mt: 2 }}
                variant="outlined"
                onClick={handleClickOpen}
              >
                Cancel this Interview
              </Button>
              <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  {"Are you sure you want to cancel this Mock Interview?"}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    you will get a complete refund after this cancellation. Read
                    {" "}
                <Link underline="hover" >
                  {"refund policy"}
                </Link>{" "}for more details
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose}>Cancel this interview</Button>
                  <Button onClick={handleClose}>Close</Button>
                </DialogActions>
              </Dialog>
            </Grid>
          </TextColumn>
        </TwoColumn>
      </Container>
    </>
  );
};
export default Issue;
